import 'ant-design-vue/lib/style/index.less'; // antd core styles
import './components/kit/vendors/antd/themes/default.less'; // default theme antd components
import './components/kit/vendors/antd/themes/dark.less'; // dark theme antd components
import './global.scss'; // app & third-party component styles
import Vue from 'vue';
import VuePageTitle from 'vue-page-title';
import NProgress from 'vue-nprogress';
import VueLayers from 'vuelayers';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './localization';
import './antd';
import './registerServiceWorker';
import './services/axios/fakeApi'; /* mocking api */
import * as ChartistTooltips from 'chartist-plugin-tooltips';
/* import 'chartist/dist/chartist.min.css'; */
import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.min';
import moment from 'moment';
import 'moment/locale/th';
import api from './api';
/* import { isMobileOnly, isTablet } from 'mobile-device-detect'; */
import VueCarousel from 'vue-carousel';
import VueConfirmDialog from 'vue-confirm-dialog';
import InfiniteScroll from 'v-infinite-scroll';
import ShareNetwork from 'vue-social-sharing';
import VueGtag from 'vue-gtag';
import _ from 'lodash';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSimpleAlert from 'vue-simple-alert';
import CustomFooter from './components/custom-footer';
import VueExpandableImage from 'vue-expandable-image';
Vue.prototype.$api = api;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueLayers);
Vue.use(NProgress);
Vue.use(VuePageTitle, {
    prefix: 'SCG Debenture Club | ',
    router,
});
Vue.use(
    VueGtag,
    {
        config: { id: 'UA-189990896-1' },
    },
    router
);
Vue.use(ChartistTooltips);
Vue.use(VueCarousel);
Vue.use(VueConfirmDialog);
Vue.use(ShareNetwork);
Vue.use(VueSimpleAlert);
Vue.use(VueExpandableImage);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.component('v-infinite-scroll', InfiniteScroll);
Vue.component('CustomFooter', CustomFooter);
Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: 'body' });
/* Vue.prototype.$device = isMobileOnly ? 'mobile' : isTablet ? 'tablet' : 'desktop'; */
Vue.prototype.$device = 'mobile';
Vue.prototype.$mode = process.env.NODE_ENV;
Vue.prototype.$public_path = process.env.VUE_APP_PUBLIC_PATH;
var os = null;
if (navigator.userAgent.indexOf('Win') != -1) os = 'windows';
if (navigator.userAgent.indexOf('Mac') != -1) os = 'Mac OS';
if (navigator.userAgent.indexOf('Linux') != -1) os = 'linux';
if (navigator.userAgent.indexOf('Android') != -1) os = 'android';
if (navigator.userAgent.indexOf('like Mac') != -1) os = 'ios';
Vue.prototype.$os = os;
Vue.mixin({
    methods: {
        smtby: function (_moment) {
            if (_moment.locale() != 'th') _moment.locale('th');
            const d = new Date(_moment.format('YYYY-MM-DD'));
            const monthShortNames = ['ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย', 'ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'];
            const christian_year = _moment.format('YYYY');
            const buddhist_year = (parseInt(christian_year) + 543).toString();
            const sub_buddhist_year = buddhist_year.slice(buddhist_year.length - 2, buddhist_year.length);
            return d.getDate() + ' ' + monthShortNames[d.getMonth()] + ' ' + sub_buddhist_year;
        },
        mtby: function (_moment, format) {
            if (_moment.locale() != 'th') _moment.locale('th');
            const christian_year = _moment.format('YYYY');
            const buddhist_year = (parseInt(christian_year) + 543).toString();
            return _moment.format(format.replace('YYYY', buddhist_year).replace('YY', buddhist_year.substring(2, 4))).replace(christian_year, buddhist_year);
        },
        ntby: function (y_s) {
            if (moment.locale() != 'th') moment.locale('th');
            const y = parseInt(y_s);
            return y - 423 < parseInt(moment().format('YYYY')) ? y + 543 : y;
        },
        nwm: function (n) {
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // qsp: function () {
        //   const query = {};
        //   query.code = localStorage.getItem('code');
        //   if (query.code)
        //     history.pushState(
        //       {},
        //       null,
        //       this.$route.path +
        //         '?' +
        //         Object.keys(query)
        //           .map((key) => {
        //             return (
        //               encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
        //             );
        //           })
        //           .join('&')
        //     );
        // },
        atg: function (a, col_num = 3) {
            /* arrayToGrid */
            const data = [];
            let row = 0;
            let col = 0;
            /* _.filter(a, (v, k) => {
              if (data[row] == undefined) data[row] = [];
              v._index = k;
              data[row][col] = v;
              col++;
              if (col > col_num - 1) {
                col = 0;
                row++;
              }
            }); */
            a.forEach((v, k) => {
                if (data[row] == undefined) data[row] = [];
                v._index = k;
                data[row][col] = v;
                col++;
                if (col > col_num - 1) {
                    col = 0;
                    row++;
                }
            });
            return data;
        },
        r(path = 'home', query = null) {
            const route_data = { path };
            if (query) route_data.query = query;
            this.$router.replace(route_data);
        },
        ine(arr = null) {
            /* Is Not Empty */
            // return _.isArray(arr) && !_.isEmpty(arr);
            return _.size(arr) > 0;
        },
        gpbw(used, total) {
            /* Get Progress Bar Width */
            try {
                let a = (used / total) * 100;
                if (a < 10) a = 0;
                else if (a > 90 && a < 100) a = 90;
                return a + '%';
            } catch (e) {
                return '0%';
            }
        },
    },
});
const url = window.location.href;
// const full_path = window.location.href.split('://');
if (url.search('debentureclub-dev.scg.com') != '-1') {
    Vue.prototype.$apiUrl = `https://apigwd.scg.com/DebentureClubDev`;
} else if (url.search('debentureclub.scg.com') != '-1') {
    Vue.prototype.$apiUrl = `https://apigw.scg.com/DebentureClub`;
} else {
    Vue.prototype.$apiUrl = `https://apigwd.scg.com/DebentureClubDev`;
}
if (Vue.prototype.$mode == 'production') console.log = () => null;
new Vue({
    router,
    store,
    nprogress,
    i18n,
    api,
    render: (h) => h(App),
}).$mount('#app');
